/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

if (n === Math.floor(n) && (n >= 0 && n <= 1))
    return 1;
return 5;
}

export default ["ti-ER",[["ቅ.ቀ.","ድ.ቀ."]],u,[["ሰ","ሰ","ሰ","ረ","ሓ","ዓ","ቀ"],["ሰን","ሰኑ","ሰሉ","ረቡ","ሓሙ","ዓር","ቀዳ"],["ሰንበት","ሰኑይ","ሰሉስ","ረቡዕ","ሓሙስ","ዓርቢ","ቀዳም"],["ሰን","ሰኑ","ሰሉ","ረቡ","ሓሙ","ዓር","ቀዳ"]],u,[["ጥ","ለ","መ","ሚ","ግ","ሰ","ሓ","ነ","መ","ጥ","ሕ","ታ"],["ጥሪ","ለካ","መጋ","ሚያ","ግን","ሰነ","ሓም","ነሓ","መስ","ጥቅ","ሕዳ","ታሕ"],["ጥሪ","ለካቲት","መጋቢት","ሚያዝያ","ጉንበት","ሰነ","ሓምለ","ነሓሰ","መስከረም","ጥቅምቲ","ሕዳር","ታሕሳስ"]],u,[["ዓ/ዓ","ዓ/ም"],u,["ዓመተ ዓለም","ዓመተ ምሕረት"]],1,[6,0],["M/d/yy","MMM d, y","MMMM d, y","EEEE፣ d MMMM y"],["h:mm a","h:mm:ss a","h:mm:ss a z","h:mm:ss a zzzz"],["{1} {0}",u,u,u],[".",",",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","#,##0%","¤#,##0.00","#E0"],"ERN","Nfk","ኤርትራዊ ናቕፋ",{"CNY":[u,"¥"],"ERN":["Nfk"],"ETB":["Br"],"JPY":[u,"¥"],"USD":["US$","$"]},"ltr", plural];
